/* ============
 * AssetComponent Module
 * ============
 */

import actions from "./actions";

export default {
  actions,
};
